/*
 * TUMLE: fills the "TUMLE: Levering" line (snippets/tumle_delivery.liquid).
 *
 * All times are Copenhagen time, whatever the visitor's clock says. Orders on
 * a weekday before the cutoff ship the same day, otherwise the next weekday.
 * Denmark: delivered data-max-days (1) weekdays after shipping, so a weekday
 * order before 14:00 is promised for tomorrow (Friday: Monday). Elsewhere
 * the line is just "Levering 1-5 dage" (data-max-days). Weekends only; Danish
 * public holidays are not handled yet.
 *
 *   Bestil inden 2 t 15 min, levering i morgen
 */
(function () {
  const DAY_NAMES = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];

  // Copenhagen wall-clock time as plain numbers
  function copenhagenNow() {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Copenhagen',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      })
        .formatToParts(new Date())
        .map((p) => [p.type, p.value])
    );
    return {
      date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
      minutes: +parts.hour * 60 + +parts.minute,
    };
  }

  const isWeekday = (d) => d.getUTCDay() !== 0 && d.getUTCDay() !== 6;
  const addDays = (d, n) => new Date(d.getTime() + n * 86400000);

  function nextWeekday(d) {
    let day = addDays(d, 1);
    while (!isWeekday(day)) day = addDays(day, 1);
    return day;
  }

  function addWeekdays(d, n) {
    let day = d;
    for (let i = 0; i < n; i++) day = nextWeekday(day);
    return day;
  }

  function render(el) {
    const [h, m] = (el.dataset.cutoff || '14:00').split(':').map(Number);
    const cutoff = h * 60 + (m || 0);
    const maxDays = Number(el.dataset.maxDays) || 3;
    const now = copenhagenNow();

    const shipsToday = isWeekday(now.date) && now.minutes < cutoff;
    const shipDate = shipsToday ? now.date : nextWeekday(now.date);

    // Delivery day. Denmark (data-from="ship"): days_dk weekdays after the
    // ship day, i.e. next day by default. Elsewhere: days_world weekdays
    // after the order day.
    const fromShip = el.dataset.from === 'ship';
    const last = addWeekdays(fromShip ? shipDate : now.date, maxDays);
    const isTomorrow = addDays(now.date, 1).getTime() === last.getTime();
    const delivery = `levering ${isTomorrow ? 'i morgen' : DAY_NAMES[last.getUTCDay()]}`;

    // When to order and when it arrives. Outside Denmark just the span.
    let main;
    if (!fromShip) {
      main = `Levering 1-${maxDays} dage`;
    } else if (shipsToday) {
      const left = cutoff - now.minutes;
      const hours = Math.floor(left / 60);
      const mins = left % 60;
      const time = hours > 0 ? `${hours} t${mins ? ` ${mins} min` : ''}` : `${mins} min`;
      main = `Bestil inden <strong>${time}</strong>, ${delivery}`;
    } else {
      main = `Bestil nu, ${delivery}`;
    }

    el.querySelector('.tumle_delivery__ship').innerHTML = main;
  }

  function renderAll() {
    document.querySelectorAll('.tumle_delivery').forEach(render);
  }

  // "Se leveringstider" opens the sheet; the close button, a click on the
  // backdrop or Esc (native <dialog>) closes it
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-tumle-delivery-open]');
    if (open) {
      const sheet = open.closest('.tumle_delivery')?.nextElementSibling;
      if (sheet && sheet.matches('dialog') && typeof sheet.showModal === 'function') sheet.showModal();
      return;
    }
    if (event.target.closest('[data-tumle-delivery-close]')) {
      event.target.closest('dialog')?.close();
      return;
    }
    if (event.target.matches('dialog.tumle_delivery-sheet')) event.target.close();
  });

  renderAll();
  // Keep the countdown honest while the page stays open
  setInterval(renderAll, 30000);
})();
